(function () {
  var form = document.querySelector('[data-vtg-apply]');
  if (!form) return;

  var endpoint = form.getAttribute('data-endpoint');
  var done = document.querySelector('[data-vtg-done]');
  var button = form.querySelector('[data-submit]');
  var label = form.querySelector('[data-label]');
  var idle = label.textContent;

  function mark(el, bad) {
    var col = el.closest('[class*="col-"]');
    var box = col ? col.querySelector('.vtg-err') : null;
    el.classList.toggle('is-invalid', bad);
    if (box) box.classList.toggle('is-shown', bad);
  }

  function validate() {
    var ok = true, first = null;
    form.querySelectorAll('.vtg-err').forEach(function (b) { b.classList.remove('is-shown'); });
    form.querySelectorAll('.is-invalid').forEach(function (b) { b.classList.remove('is-invalid'); });

    form.querySelectorAll('[required]').forEach(function (el) {
      var v = el.value.trim();
      var bad = !v;
      if (!bad && el.minLength > 0 && v.length < el.minLength) bad = true;
      if (!bad && el.pattern && !(new RegExp(el.pattern).test(v))) bad = true;
      if (!bad && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) bad = true;
      if (bad) { ok = false; first = first || el; mark(el, true); }
    });

    var phone = form.querySelector('[name="phone"]');
    var digits = phone.value.replace(/[^\d+]/g, '');
    if (phone.value.trim() && !/^\+?\d{7,15}$/.test(digits)) { ok = false; first = first || phone; mark(phone, true); }

    var channels = Array.prototype.slice.call(form.querySelectorAll('[name="channels"]:checked')).map(function (c) { return c.value; });
    if (!channels.length) {
      ok = false;
      form.querySelector('[data-err-channels]').classList.add('is-shown');
      first = first || form.querySelector('[data-channels]');
    }
    var needsPhone = channels.indexOf('sms') > -1 || channels.indexOf('whatsapp') > -1;
    if (needsPhone && !digits) {
      ok = false;
      form.querySelector('[data-err-phone]').classList.add('is-shown');
      phone.classList.add('is-invalid');
      first = first || phone;
    }

    if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return ok;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate()) return;

    var payload = { brands: [], channels: [] };
    new FormData(form).forEach(function (v, k) {
      if (k === 'brands' || k === 'channels') payload[k].push(v);
      else payload[k] = typeof v === 'string' ? v.trim() : v;
    });
    payload.phone = (payload.phone || '').replace(/[^\d+]/g, '');
    payload.source = 'theme-form';
    payload.page = location.href;

    button.disabled = true;
    label.textContent = 'Sending…';
    form.querySelector('[data-err-form]').classList.remove('is-shown');

    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw r; return r.json().catch(function () { return { ok: true }; }); })
      .then(function () {
        form.hidden = true;
        done.hidden = false;
        done.scrollIntoView({ block: 'center', behavior: 'smooth' });
      })
      .catch(function () {
        button.disabled = false;
        label.textContent = idle;
        form.querySelector('[data-err-form]').classList.add('is-shown');
      });
  });
})();
